import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

import { GetUserIdentityDocument } from 'src/generated/graphql';
import { useAuth } from 'src/hooks/auth';
import { tracking } from 'src/tracking';
import { setGtagUserId } from 'src/utils/new-analytics/gtm';

export const GoogleAnalyticsUserSync = () => {
  const { authLoaded, getAuthToken } = useAuth();
  const isLoggedIn = authLoaded && Boolean(getAuthToken());

  const getUserIdentityResult = useQuery(GetUserIdentityDocument, {
    skip: !isLoggedIn,
  });

  useEffect(() => {
    if (!authLoaded) return;

    if (!isLoggedIn) {
      setGtagUserId(null);
      return;
    }

    if (
      !getUserIdentityResult.loading &&
      getUserIdentityResult.data?.user?.userId
    ) {
      setGtagUserId(getUserIdentityResult.data.user.userId);
      // It's awkward that this lives here but we *need* this to happen after
      // we've set the above userId in GA
      tracking.sitewide.auth.userLoaded();
    }
  }, [
    authLoaded,
    isLoggedIn,
    getUserIdentityResult.loading,
    getUserIdentityResult.data?.user?.userId,
  ]);

  return null;
};
